import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { CHANGE_TOPIC } from './types';
var IS_NOT_MATCHED_VALUE = 'IS_NOT_MATCHED_VALUE';
export var CheckedMode = {
  // 只返回全选数据，包含父节点和子节点
  Full: 0,
  // 返回全部选择字节点和部分选中的父节点
  Half: 1,
  // 只返回选中子节点
  Child: 2,
  // 如果父节点下所有子节点全部选中，只返回父节点
  Shallow: 3,
  // 所选即所得
  Freedom: 4
};

// check status stack
var checkStatusStack = function checkStatusStack(stack, defaultStatus) {
  if (!stack || stack.length <= 0) return defaultStatus;
  if (stack.filter(function (d) {
    return d === 0;
  }).length === stack.length) return 0;
  var s = stack.filter(function (d) {
    return d === 0 || d === 2;
  });
  if (s.length <= 0) return defaultStatus;
  return 2;
};

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      data: [],
      childrenKey: ''
    };

    _classCallCheck(this, _default);

    this.keygen = void 0;
    this.mode = void 0;
    this.unmatch = void 0;
    this.disabled = void 0;
    this.childrenKey = void 0;
    this.valueMap = void 0;
    this.unmatchedValueMap = void 0;
    this.events = void 0;
    this.$events = void 0;
    this.value = void 0;
    this.data = void 0;
    this.cachedValue = void 0;
    this.pathMap = void 0;
    this.dataMap = void 0;
    var data = options.data,
        value = options.value,
        keygen = options.keygen,
        mode = options.mode,
        disabled = options.disabled,
        _options$childrenKey = options.childrenKey,
        childrenKey = _options$childrenKey === void 0 ? 'children' : _options$childrenKey,
        unmatch = options.unmatch;
    this.keygen = keygen;
    this.mode = mode;
    this.valueMap = new Map();
    this.unmatchedValueMap = new Map();
    this.unmatch = unmatch;
    this.events = new Map();
    this.$events = {};
    this.childrenKey = childrenKey;
    this.updateDisabled(disabled);
    this.setValue(value);
    this.setData(data);
  }

  _createClass(_default, [{
    key: "updateDisabled",
    value: function updateDisabled(dis) {
      if (typeof dis === 'function') {
        this.disabled = dis;
      } else {
        this.disabled = function () {
          return false;
        };
      }
    }
  }, {
    key: "bind",
    value: function bind(id, update) {
      this.events.set(id, update);
    }
  }, {
    key: "unbind",
    value: function unbind(id) {
      this.events["delete"](id);
    }
  }, {
    key: "setUnmatedValue",
    value: function setUnmatedValue() {
      var _this = this;

      this.unmatchedValueMap = new Map();
      if (!this.value || !this.data) return;
      this.value.forEach(function (v) {
        var data = _this.getDataById(v);

        var unmatched = _this.isUnMatch(data);

        if (unmatched) _this.unmatchedValueMap.set(v, true);else _this.unmatchedValueMap["delete"](v);
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "isUnMatch",
    value: function isUnMatch(data) {
      return data && data[IS_NOT_MATCHED_VALUE];
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.value = value;

      if (value && value !== this.cachedValue) {
        this.initValue();
      }

      this.setUnmatedValue();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this2 = this;

      var value = [];
      this.valueMap.forEach(function (checked, id) {
        switch (_this2.mode) {
          case CheckedMode.Full:
          case CheckedMode.Freedom:
            if (checked === 1) value.push(id);
            break;

          case CheckedMode.Half:
            if (checked >= 1) value.push(id);
            break;

          case CheckedMode.Child:
            if (checked === 1) {
              var info = _this2.pathMap.get(id);

              if (info && info.children.length === 0) value.push(id);
            }

            break;

          case CheckedMode.Shallow:
            if (checked === 1) {
              var parentChecked = function () {
                var info = _this2.pathMap.get(id);

                if (!info) return false;
                var path = info.path;
                var pid = path[path.length - 1];
                if (!pid && pid !== 0) return false;
                return _this2.valueMap.get(pid) === 1;
              }();

              if (!parentChecked) value.push(id);
            }

            break;

          default:
        }
      });
      this.unmatchedValueMap.forEach(function (unmatch, id) {
        if (unmatch && _this2.unmatch) value.push(id);
      });
      this.cachedValue = value;
      return value;
    }
  }, {
    key: "setValueMap",
    value: function setValueMap(id, checked) {
      this.valueMap.set(id, checked);
      var update = this.events.get(id);
      if (update) update();
    }
  }, {
    key: "set",
    value: function set(id, checked, direction) {
      var _this3 = this;

      // self
      if (!this.isDisabled(id)) this.setValueMap(id, checked);
      var data = this.getDataById(id);

      if (data && data[IS_NOT_MATCHED_VALUE]) {
        if (checked) this.unmatchedValueMap.set(id, true);else this.unmatchedValueMap["delete"](id);
        return null;
      }

      if (CheckedMode.Freedom === this.mode) {
        // Free mode will return zero
        return 0;
      }

      var _ref = this.pathMap.get(id),
          path = _ref.path,
          children = _ref.children;

      var childrenStack = []; // children

      if (direction !== 'asc') {
        children.forEach(function (cid) {
          // push status to stack
          childrenStack.push(_this3.set(cid, checked, 'desc'));
        });
      } // Exclude disabled


      var current = this.valueMap.get(id); // check all children status

      var status = checkStatusStack(childrenStack, current);

      if (status !== current) {
        this.setValueMap(id, status);
        current = status;
      } // parent


      if (direction !== 'desc' && path.length > 0) {
        var parentId = path[path.length - 1];
        var parentChecked = current;
        this.pathMap.get(parentId).children.forEach(function (cid) {
          if (parentChecked !== _this3.valueMap.get(cid)) {
            parentChecked = 2;
          }
        });
        this.set(parentId, parentChecked, 'asc');
      }

      return current;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(id) {
      var node = this.pathMap.get(id);
      if (node) return node.isDisabled;
      return false;
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.valueMap.get(id);
    }
  }, {
    key: "getDataById",
    value: function getDataById(id) {
      var _ref2;

      var oroginData = this.dataMap.get(id);
      if (oroginData) return oroginData;
      if (!this.unmatch) return null;
      return _ref2 = {}, _defineProperty(_ref2, IS_NOT_MATCHED_VALUE, true), _defineProperty(_ref2, "value", id), _ref2;
    }
  }, {
    key: "getPath",
    value: function getPath(id) {
      return this.pathMap.get(id);
    }
  }, {
    key: "getChecked",
    value: function getChecked(id) {
      var value = this.get(id);
      var checked = value === 1;
      if (value === 2) checked = 'indeterminate';
      return checked;
    }
  }, {
    key: "getKey",
    value: function getKey(data) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var index = arguments.length > 2 ? arguments[2] : undefined;
      if (typeof this.keygen === 'function') return this.keygen(data, id);
      if (this.keygen) return data[this.keygen];
      return id + (id ? ',' : '') + index;
    }
  }, {
    key: "initValue",
    value: function initValue(ids, forceCheck) {
      var _this4 = this;

      if (!this.data || !this.value) return undefined;

      if (!ids) {
        ids = [];
        this.pathMap.forEach(function (val, id) {
          if (val.path.length === 0) ids.push(id);
        });
      }

      var checked;
      ids.forEach(function (id) {
        var _ref3 = _this4.pathMap.get(id),
            children = _ref3.children;

        if (forceCheck) {
          _this4.setValueMap(id, 1);

          _this4.initValue(children, forceCheck);

          return;
        }

        var childChecked = _this4.value.indexOf(id) >= 0 ? 1 : 0;

        if (childChecked === 1 && _this4.mode !== CheckedMode.Half && _this4.mode !== CheckedMode.Freedom) {
          _this4.initValue(children, true);
        } else if (children.length > 0) {
          // 保持迭代
          var res = _this4.initValue(children);

          childChecked = _this4.mode === CheckedMode.Freedom ? childChecked : res;
        } else {
          childChecked = _this4.value.indexOf(id) >= 0 ? 1 : 0;
        }

        _this4.setValueMap(id, childChecked);

        if (checked === undefined) checked = childChecked;else if (checked !== childChecked) checked = 2;
      });
      return checked;
    }
  }, {
    key: "initData",
    value: function initData(data, path, disabled) {
      var _this5 = this;

      var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var ids = [];
      data.forEach(function (d, i) {
        var id = _this5.getKey(d, path[path.length - 1], i);

        if (_this5.dataMap.get(id)) {
          console.error("There is already a key \"".concat(id, "\" exists. The key must be unique."));
          return;
        }

        _this5.dataMap.set(id, d);

        var isDisabled = !!disabled;

        if (!isDisabled && typeof _this5.disabled === 'function') {
          isDisabled = _this5.disabled(d, i);
        }

        var indexPath = [].concat(_toConsumableArray(index), [i]);
        ids.push(id);
        var children = [];

        if (Array.isArray(d[_this5.childrenKey])) {
          children = _this5.initData(d[_this5.childrenKey], [].concat(_toConsumableArray(path), [id]), // exclude Freedom
          _this5.mode === CheckedMode.Freedom ? disabled : isDisabled, indexPath);
        }

        _this5.pathMap.set(id, {
          children: children,
          path: path,
          isDisabled: isDisabled,
          indexPath: indexPath,
          index: i
        });
      });
      return ids;
    }
  }, {
    key: "setData",
    value: function setData(data, dispatch) {
      var prevValue = this.value || [];
      this.cachedValue = [];
      this.pathMap = new Map();
      this.dataMap = new Map();
      this.valueMap = new Map();
      this.unmatchedValueMap = new Map();
      this.data = data;
      if (!data) return;
      this.initData(data, []);
      this.initValue();
      this.setValue(prevValue);
      if (dispatch) this.dispatch(CHANGE_TOPIC);
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      if (!this.$events[name]) this.$events[name] = [];
      var events = this.$events[name];
      if (events.includes(fn)) return;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      if (!this.$events[name]) return;
      this.$events[name] = this.$events[name].filter(function (e) {
        return e !== fn;
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var event = this.$events[name];
      if (!event) return;
      event.forEach(function (fn) {
        return fn.apply(void 0, args);
      });
    }
  }]);

  return _default;
}();

export { _default as default };